export default __webpack_public_path__ + "static/media/wolfram.107b7982.png";